module.exports = __webpack_public_path__ + "img/airplane.7ed69a82.png";